import { createFileRoute } from '@tanstack/react-router';

import { useTelegramBackButton } from '@common/hooks';
import { Page } from '@common/ui/Page';

import { MainSettings } from '@widgets/settings/MainSettings';

export const Route = createFileRoute('/profile/settings/')({
  component: Component,
});

export default function Component() {
  useTelegramBackButton({ to: 'back' });

  return (
    <>
      <Page style={{ padding: '8px 0' }}>
        <MainSettings />
      </Page>
    </>
  );
}
